import React from 'react';
import PropTypes from 'prop-types';

import { UI_LANDING_STYLE_PREFIX } from '../../../constants/appConstants';

const Title = (props) => {
  const { value } = props;

  const namespace = `${UI_LANDING_STYLE_PREFIX}-title-component`;

  const { title } = value;

  return <h1 className={`${namespace}`}>{title}</h1>;
};

Title.propTypes = {
  value: PropTypes.shape({
    title: PropTypes.string.isRequired,
  }).isRequired,
};

export default Title;
